// src/pages/ContactUsPage/ContactUsPage.tsx

import React from "react";

const ContactUsPage: React.FC = () => {
  return (
    <div>
      <h1>Contact Us Page</h1>
      {/* 你的页面内容 */}
    </div>
  );
};

export default ContactUsPage;
